<template>
  <a-row class="content-fix" type="flex">
    <spinner v-if="loading" />

    <a-col v-else class="height100 flex-1">
      <a-tabs :key="$route.fullPath" class="main-tabs" type="card">
        <a-tab-pane key="content">
          <span slot="tab"> <a-icon type="project" />Содержимое </span>

          <!-- lang tabs -->
          <a-row align="middle" class="flex-baseline input-form__group">
            <a-col :span="6" style="text-align: right; padding-right: 8px">
              Язык:
            </a-col>
            <a-col :span="12">
              <!-- lang translit tabs -->
              <a-row align="middle" class="flex-baseline flex-wrap">
                <lang-tabs v-model="langTab" class="mb-1x" />
              </a-row>
            </a-col>
          </a-row>

          <!-- avatar -->
          <a-row align="middle" class="input-form__group">
            <a-col
              :span="6"
              style="text-align: right; padding-top: 4px; padding-right: 8px"
            >
              Фото:
            </a-col>
            <a-col :span="12">
              <a-row align="top" type="flex">
                <a-avatar
                  :size="86"
                  :src="ccAvatar"
                  icon="user"
                  shape="square"
                />

                <input
                  ref="avatarInputRef"
                  accept="image/jpeg, image/png"
                  hidden
                  type="file"
                  @change="handleAvatar"
                />
                <a-button class="ml-1x" @click="showModal(true)">
                  Выбрать
                </a-button>

                <a-button class="ml-1x" @click="removeAvatar">
                  Удалить
                </a-button>
              </a-row>
              <!--              <div class="error-text" v-if="!$v.avatar.required">-->
              <!--                Выберите изображение.-->
              <!--              </div>-->
            </a-col>
          </a-row>

          <!-- full name -->
          <a-row align="middle" class="flex-baseline input-form__group">
            <a-col :span="6" style="text-align: right; padding-right: 8px">
              Ф.И.О:
            </a-col>
            <a-col :span="12">
              <a-input
                v-model.trim="form.full_name[langTab]"
                placeholder="Введите Ф.И.О"
              />
            </a-col>
          </a-row>
          <!-- autobiography -->
          <a-row align="top" class="input-form__group" type="flex">
            <a-col
              :span="6"
              style="text-align: right; padding-top: 5px; padding-right: 8px"
            >
              Должность:
            </a-col>
            <a-col :span="12">
              <a-textarea
                v-model="form.autobiography[langTab]"
                :autosize="{ minRows: 2, maxRows: 6 }"
                placeholder="Введите должность"
              />
            </a-col>
          </a-row>

          <!-- phone -->
          <a-row align="top" class="input-form__group" type="flex">
            <a-col
              :span="6"
              style="text-align: right; padding-top: 5px; padding-right: 8px"
            >
              Номер телефона:
            </a-col>
            <a-col :span="12">
              <a-input v-model="form.phone" placeholder="+998 (XX) XXX-XX-XX" />
            </a-col>
          </a-row>

          <!-- work days -->
          <a-row align="top" class="input-form__group" type="flex">
            <a-col
              :span="6"
              style="text-align: right; padding-top: 5px; padding-right: 8px"
            >
              Дни приема:
            </a-col>
            <a-col :span="12">
              <a-textarea
                v-model="form.work_days[langTab]"
                :autosize="{ minRows: 2, maxRows: 6 }"
                placeholder="Введите дни приема"
              />
            </a-col>
          </a-row>

          <!-- commitment -->
          <a-row align="middle" class="flex-baseline input-form__group">
            <a-col :span="6" style="text-align: right; padding-right: 8px">
              Обязательство:
            </a-col>
            <a-col :span="12">
              <a-input
                v-model="form.commitment[langTab]"
                placeholder="Введите обязательство"
              />
            </a-col>
          </a-row>

          <!-- editor -->
          <a-row align="middle" class="input-form__group">
            <a-col
              :span="6"
              style="padding-top: 4px; text-align: right; padding-right: 8px"
            >
              Прочее:
            </a-col>
            <a-col :span="24">
              <editor
                :key="'tinymce_' + langTab"
                v-model="form.additional_data[langTab]"
                :init="{
                  height: 450,
                  plugins: [
                    'advlist autolink lists link image imagetools charmap print preview',
                    'searchreplace visualblocks code fullscreen',
                    'insertdatetime media table paste code wordcount'
                  ],
                  fontsize_formats:
                    '8px 10px 12px 14px 16px 18px 24px 36px 40px 72px',
                  toolbar:
                    'undo redo | preview fullscreen | formatselect fontsizeselect | bold italic underline forecolor | \
                  image link table insertfile code | hr alignleft aligncenter alignright alignjustify | \
                  bullist numlist outdent indent | removeformat',
                  language: 'ru',
                  language_url: '/js/tinymce/langs/ru.js',
                  menubar: false,
                  images_upload_url: false,
                  automatic_uploads: false,
                  relative_urls: false,
                  images_reuse_filename: true,
                  images_dataimg_filter: function (img) {
                    return img.hasAttribute('internal-blob')
                  },
                  images_upload_handler: $_editorUpdloadHandler
                }"
                api-key="3myux81vzip0v5yxik8wex3sk4vgt37xuna840e8nzco3rs5"
              />
            </a-col>
          </a-row>

          <!-- position -->
          <a-row align="middle" class="flex-baseline input-form__group">
            <a-col :span="6" style="text-align: right; padding-right: 8px">
              Позиция:
            </a-col>
            <a-col :span="12">
              <a-input
                v-model.number="form.position"
                placeholder="Введите позицию"
                @keypress="isNumber"
              />
            </a-col>
          </a-row>

          <!-- status toggle -->
          <a-row class="input-form__group">
            <a-col :span="6" style="text-align: right; padding-right: 8px">
              Статус:
            </a-col>
            <a-switch v-model="form.status" />
          </a-row>
        </a-tab-pane>
      </a-tabs>

      <a-row class="form-buttons__action" type="flex">
        <a-col :span="6" style="text-align: right; padding-right: 8px" />
        <a-col>
          <a-button :disabled="pending" @click="$router.go(-1)">
            <a-icon type="close" />Отмена
          </a-button>

          <a-button
            :loading="pending"
            style="margin-left: 10px"
            type="primary"
            @click="submit"
          >
            <a-icon type="check" />
            {{ form.id ? "Сохранить" : "Добавить" }}
          </a-button>
        </a-col>
      </a-row>
    </a-col>
    <osg-cropper
      v-if="showForm"
      v-model="showForm"
      :ratio-width="19"
      :ratio-height="23"
      :quality="0.9"
      @onImageSelected="setImageExtention"
      @onSetImage="getImage"
    />
  </a-row>
</template>

<script>
import Editor from "@tinymce/tinymce-vue"

import { mapActions, mapGetters } from "vuex"

const fields = {
  full_name: {
    uz: "",
    oz: "",
    en: "",
    ru: ""
  },
  position: 1,
  phone: "",
  work_days: {
    uz: "",
    oz: "",
    en: "",
    ru: ""
  },
  autobiography: {
    uz: "",
    oz: "",
    en: "",
    ru: ""
  },
  commitment: {
    uz: "",
    oz: "",
    en: "",
    ru: ""
  },
  leader_position: {
    uz: "",
    oz: "",
    en: "",
    ru: ""
  },
  status: true,
  avatar: null,
  additional_data: {
    uz: "",
    oz: "",
    en: "",
    ru: ""
  }
}

export default {
  components: {
    "osg-cropper": () => import("@/components/imageCrop/modalCrop"),
    editor: Editor
  },
  data() {
    return {
      fileExtension: "jpeg",
      showForm: false,
      form: { ...fields },
      loading: false,
      pending: false,
      langTab: $langPrefix,
      avatar: null
    }
  },

  computed: {
    ...mapGetters("leadership", { leadersList: "list" }),
    cAvatar: {
      get() {
        if (this.avatar) {
          return URL.createObjectURL(this.avatar)
        }

        if (this.form.avatar) {
          return this.filesUrl + this.form.avatar
        }

        return require("@/assets/img/no-photo-1.png")
      }
    },
    ccAvatar: {
      get() {
        if (this.avatar) {
          return URL.createObjectURL(this.avatar)
        }

        if (this.form.avatar) {
          return this.filesUrl + this.form.avatar
        }

        return ""
      }
    },

    isContentNull() {
      return !!(
        !this.form.content.uz &&
        !this.form.content.oz &&
        !this.form.content.ru &&
        !this.form.content.en
      )
    }
  },

  watch: {
    $route: {
      handler: "fetchData",
      immediate: true
    }
  },
  beforeDestroy() {
    this.clearForm()
  },

  methods: {
    ...mapActions("leadership", ["detail"]),
    clearForm() {
      console.log("clearForm")
      this.$set(this, "form", {
        ...fields
      })
    },
    setImageExtention(e) {
      this.fileExtension = e
    },
    showModal(value) {
      this.showForm = value
    },
    handleAvatar(e) {
      if (e.target.files && e.target.files[0]) {
        this.avatar = e.target.files[0]
      }

      this.$refs.avatarInputRef.value = null
    },
    urltoFile(url, filename, mimeType) {
      return fetch(url)
        .then(function (res) {
          return res.arrayBuffer()
        })
        .then(function (buf) {
          return new File([buf], filename, { type: mimeType })
        })
    },
    getImage(variable) {
      "jpeg",
        this.urltoFile(
          variable,
          this.fileExtension,
          `image/${this.fileExtension}`
        ).then((file) => {
          this.avatar = file
        })
    },
    removeAvatar() {
      this.avatar = null
      this.form.avatar = null
    },

    async fetchData() {
      this.loading = true

      this.$set(this, "form", {
        ...fields
      })

      try {
        if (this.$route.params.id) {
          const res = await this.detail(this.$route.params.id)

          if (res) {
            this.$set(this, "form", {
              ...res,
              autobiography: (res.autobiography &&
                JSON.parse(res.autobiography)) || {
                ...this.langKeys
              },
              full_name: (res.full_name && JSON.parse(res.full_name)) || {
                ...this.langKeys
              },
              work_days: (res.work_days && JSON.parse(res.work_days)) || {
                ...this.langKeys
              },
              commitment: (res.commitment && JSON.parse(res.commitment)) || {
                ...this.langKeys
              },
              additional_data: (res.additional_data &&
                JSON.parse(res.additional_data)) || {
                ...this.langKeys
              }
            })
          }
        }
      } catch (e) {
        console.log(e)
        this.loading = false
      }

      this.loading = false
    },
    async submit() {
      // do your submit logic here
      this.pending = true

      const f = new FormData()
      Object.keys(this.form).forEach((key) => {
        if (this.form[key] !== undefined) {
          if (!isNaN(this.form[key])) {
            f.append(key, this.form[key])
          } else {
            if (key === "phone" || key === "avatar") {
              // if(this.form[key] !== null){
              f.append(key, this.form[key])
              // }
            } else {
              f.append(key, JSON.stringify(this.form[key]))
            }
          }
        }
      })
      if (this.avatar) {
        f.append("avatar", this.avatar)
      } else if (!this.form.avatar && this.form.id) {
        this.DeleteAvatar()
      } else {
        f.append("avatar", JSON.stringify(this.form["avatar"]))
      }

      try {
        const res = await this.$store.dispatch(
          `leadership/${this.form.id ? "update" : "create"}ItemAction`,
          {
            id: this.form.id || null,
            data: f
          }
        )

        if (res && res.data && res.data.id) {
          this.$message.success("Успешно сохранено")
          this.$router.go(-1)
        }
      } catch (e) {
        console.log(e)
        this.pending = false
      }

      this.pending = false
    },
    async DeleteAvatar() {
      try {
        const res = await this.$store.dispatch(
          `leadership/DeleteAvatar`,
          this.form.id
        )

        if (res) {
          this.$message.success("Успешно удалено")
          this.pending = false
        }
      } catch (e) {
        console.log(e)
        this.pending = false
      }
    }
  }
}
</script>
